import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";
import MainImg from "../../../assets/img/blog/christmas/MainChristmas.webp"; 

import Brooks from "../../../assets/img/blog/christmas/Brooks.avif"; 
import Campbells from "../../../assets/img/blog/christmas/Campbells.webp"; 
import Pingles from "../../../assets/img/blog/christmas/Pingles.webp"; 
import Willowtree from "../../../assets/img/blog/christmas/Willowtree.webp"; 

const CHRISTMAS_SECTIONS = [
  {
    farms: [
      {
        name: "Pingle’s Farm Market",
        img: Pingles,
        subTitle: "Ugly Christmas Sweater Parties!",
        description: "Get ready to don your tackiest holiday knits at Pingle’s Farm Market! Their Ugly Christmas Sweater parties are the perfect way to kick off the festive season with friends and family. Enjoy a vibrant atmosphere filled with holiday cheer, delicious seasonal treats, and plenty of photo ops to show off your festive fashion.",
        location: "1805 Taunton Rd E, Hampton, ON",
        website: "Pingle’s Farm Market",
        webUrl: "https://pinglesfarmmarket.com/",
        details: [
          { label: "Event", value: "Ugly Christmas Sweater Parties" },
          { label: "Highlights", value: "Live Music & Festive Tunes | Holiday-Themed Cocktails & Mocktails | Delicious Farm-Fresh Food | Greenhouse dining experience | Best Ugly Sweater Contest" }
        ]
      },
      {
        name: "Willowtree Farm",
        img: Willowtree,
        subTitle: "Adventures with Santa",
        description: "Experience the magic of the holidays at Willowtree Farm with their heartwarming 'Adventures with Santa' event. It’s a wonderful opportunity for the little ones to meet the jolly old man himself in a rustic, cozy farm setting. Create lasting memories as you explore the farm and enjoy the winter wonderland.",
        location: "975 Regional Rd 21, Port Perry, ON",
        website: "Willowtree Farm",
        webUrl: "https://willowtreefarm.ca/",
        details: [
          { label: "Event", value: "Adventures with Santa" },
          { label: "Highlights", value: "Meet & Greet with Santa Claus | Storytime sessions | Crafting workshops for kids | Hot cocoa and festive treats | Photo opportunities in the sleigh" }
        ]
      },
      {
        name: "Brooks Farms",
        img: Brooks,
        subTitle: "Festive Nights",
        description: "When the sun goes down, Brooks Farms lights up with 'Festive Nights'. This evening event transforms the farm into a glowing holiday spectacle. It’s perfect for families looking for an enchanting night out, complete with sparkling lights and outdoor fun under the stars.",
        location: "122 Ashworth Rd, Mount Albert, ON",
        website: "Brooks Farms",
        webUrl: "https://www.brooksfarms.com/",
        details: [
          { label: "Event", value: "Festive Nights" },
          { label: "Highlights", value: "Spectacular Light Displays | Nighttime Wagon Rides | Bonfires for roasting marshmallows | Holiday Scavenger Hunt | Meet Santa in the festive barn" }
        ]
      },
      {
        name: "Campbell’s Cross Farm",
        img: Campbells,
        subTitle: "Marshmallow World",
        description: "Step into a 'Marshmallow World' at Campbell’s Cross Farm. This dreamy event is all about cozy vibes and sweet treats. Wander through the farm’s scenic grounds, enjoy the crisp winter air, and warm up with gooey, delicious marshmallows by the fire. It's a picturesque escape from the city.",
        location: "3634 King St, Caledon, ON",
        website: "Campbell’s Cross Farm",
        webUrl: "https://www.campbellscrossfarm.com/",
        details: [
          { label: "Event", value: "Marshmallow World" },
          { label: "Highlights", value: "Marshmallow roasting stations | Hot Chocolate Bar | Nature walks through the snow | Festive workshops (wreath making) | Instagram-worthy holiday decor" }
        ]
      }
    ]
  }
];

export default function Christmas() {
  return (
    <div className={styles.page}>

      {/* Top meta like blogTO */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>Event</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti Team</span>
        <span className={styles["sep"]}>•</span>
        <span>December 10, 2025</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>4 Must-Visit Farms Near Toronto Before Christmas</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={MainImg}
          alt="Christmas on the Farm"
        />
      </div>

      <div className={styles["lead-section"]}>
        <p><strong>Embrace the holiday spirit with a trip to the countryside!</strong><br/>
        There’s no better way to get ready for the holidays than visiting a local farm. Just a short drive from Toronto, these farms transform into winter wonderlands, offering unique experiences that go far beyond the typical mall Santa visit.</p>
        <p>From cozy bonfires and ugly sweater parties to enchanting light displays and marshmallow roasting, these 4 destinations promise festive fun for everyone. Gather your friends and family, bundle up, and head out to explore what these amazing farms have to offer this Christmas season.</p>
      </div>

      {CHRISTMAS_SECTIONS.map((section, idx) => (
        <div key={idx}>
          <hr className={styles["region-divider"]} />
          
          {section.farms.map((farm, fIdx) => (
            <div key={fIdx} className={styles["farm-section"]}>
              <h3 className={styles["farm-name"]}>{farm.name}</h3>
              <hr className={styles["region-divider"]} />
              
              {farm.img && <img src={farm.img} alt={farm.name} className={styles["farm-image"]} />}
              
              <div className={styles["farm-description"]}>
                <p><strong>{farm.subTitle}</strong></p>
                <p>{farm.description}</p>
              </div>

              <div className={styles["event-details-title"]}>Event Details:</div>
              <ul className={styles["details-list"]}>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Location:</span> {farm.location}
                </li>
                {farm.website && (
                    <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Website:</span><br />
                    <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                        {farm.website}
                    </a>
                    </li>
                )}
                {farm.details && farm.details.map((detail, dIdx) => (
                  <li key={dIdx} className={styles["details-item"]}>
                    <span className={styles["details-label"]}>{detail.label}:</span> {detail.value}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ))}
      <div className={styles["bottom-spacer"]} />
    </div>
  );
}
